import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core"
import { CollectionNode } from "../../../models/collectionNode.model"
import { CollectionResourceRequestParams } from "../../../models/collectionResourceRequestParams.model"
import { CollectionService } from "../../../services/collection.service"

@Component({
    selector: "app-paginated-resources",
    templateUrl: "./paginated-resources.component.html",
    styleUrls: ["./paginated-resources.component.scss"],
    standalone: false,
})
export class PaginatedResourcesComponent implements OnInit, OnChanges {
    @Input() public collection: CollectionNode
    public currentIndex: number
    public currentPage: number
    public paginationSize: number

    constructor(private collectionService: CollectionService) {}

    public ngOnInit() {
        this.paginationSize = this.collectionService.collectionResourceCount
        this.currentIndex = 0
        this.changePage()
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (
            changes.collection.previousValue &&
            changes.collection.previousValue.id !== changes.collection.currentValue.id
        ) {
            this.currentIndex = 0
            this.currentPage = 0
        }
    }

    public seeMore() {
        this.changePage(1)
        this.backToTop()
    }

    public seeLess() {
        this.changePage(-1)
        this.backToTop()
    }

    public canSeeMore(): boolean {
        if (this.collection.resources[this.currentPage]) {
            return (
                this.currentIndex + this.collection.resources[this.currentPage].length <
                    this.collection.totalResources || this.collection.isLoadingResources
            )
        }
        return false
    }

    public canSeeLess(): boolean {
        if (this.collection.resources[this.currentPage]) {
            return (
                this.currentIndex - this.collection.resources[this.currentPage].length >= 0 ||
                this.collection.isLoadingResources
            )
        }
        return false
    }

    /**
     * @description
     * Changes the page and loads resources if needed
     * @param moreOrLess 1 or -1
     */
    public changePage(moreOrLess: number = null) {
        if (moreOrLess === 1 && this.currentIndex < this.collection.totalResources) {
            this.currentIndex += this.paginationSize
        }

        if (moreOrLess === -1 && this.currentIndex >= this.paginationSize) {
            this.currentIndex -= this.paginationSize
        }

        this.currentPage = this.collectionService.getPage(this.currentIndex, this.paginationSize)

        if (moreOrLess && !this.hasCurrentCollectionPageResources) {
            const params: CollectionResourceRequestParams = new CollectionResourceRequestParams(
                this.currentIndex,
                this.paginationSize,
                this.collection.id
            )
            this.collectionService.loadResourceFor(this.collection, params)
        }
    }

    public goToPage(page: number) {
        this.currentPage = page
        this.currentIndex = this.currentPage * this.paginationSize
        if (!this.hasCurrentCollectionPageResources) {
            const params: CollectionResourceRequestParams = new CollectionResourceRequestParams(
                this.currentIndex,
                this.paginationSize,
                this.collection.id
            )
            this.collectionService.loadResourceFor(this.collection, params)
        }
        this.backToTop()
    }

    private get hasCurrentCollectionPageResources(): boolean {
        return !!this.collection.resources[this.currentPage].length || false
    }

    public backToTop() {
        document.querySelector(".resources-section").scrollIntoView({
            behavior: "auto",
            block: "start",
            inline: "nearest",
        })
    }
}
